export function sanityLoader({ src, width, quality }) {
  if (!src.startsWith('https://cdn.sanity.io')) {
    return src;
  }
  const url = new URL(src);
  url.searchParams.set('w', width);
  url.searchParams.set('q', quality || 75);
  url.searchParams.set('fm', 'webp');
  return url.toString();
}
